type Props = {
  width?: number;
  height?: number;
};

export function AutoLayoutIcon({ width = 18, height = 18 }: Props) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 5.25L15.705 3.705L17.25 3L15.705 2.295L15 0.75L14.295 2.295L12.75 3L14.295 3.705L15 5.25ZM6.375 5.25L7.08 3.705L8.625 3L7.08 2.295L6.375 0.75L5.67 2.295L4.125 3L5.67 3.705L6.375 5.25ZM15 9.375L14.295 10.92L12.75 11.625L14.295 12.33L15 13.875L15.705 12.33L17.25 11.625L15.705 10.92L15 9.375ZM13.2825 6.84L11.16 4.7175C11.01 4.575 10.8225 4.5 10.6275 4.5C10.4325 4.5 10.245 4.575 10.095 4.7175L1.7175 13.095C1.64797 13.1644 1.59281 13.2468 1.55518 13.3375C1.51754 13.4283 1.49817 13.5255 1.49817 13.6238C1.49817 13.722 1.51754 13.8192 1.55518 13.91C1.59281 14.0007 1.64797 14.0831 1.7175 14.1525L3.84 16.275C3.99 16.425 4.1775 16.5 4.3725 16.5C4.5675 16.5 4.755 16.425 4.905 16.2825L13.2825 7.905C13.575 7.6125 13.575 7.1325 13.2825 6.84ZM10.6275 6.315L11.685 7.3725L10.8075 8.25L9.75 7.1925L10.6275 6.315ZM4.3725 14.6925L3.315 13.635L8.6925 8.25L9.75 9.3075L4.3725 14.6925Z"
        fill="currentColor"
      />
    </svg>
  );
}
